import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/motion";
import { WaitlistForm } from "@/components/site/WaitlistForm";

const PILLARS = [
  { n: "I", t: "Stewardship", b: "Every gift is recorded against the fund it was given for, and a single deposit can be split across several funds until it is fully allocated." },
  { n: "II", t: "Transparency", b: "Nested funds roll up into their parents, and every move or adjustment between funds is kept in the Fund Activity history." },
  { n: "III", t: "Audit-ready", b: "Reconcile cleared balances against the bank statement, then print or download the monthly Treasurer's Report as a PDF." },
];

export const Trust = () => (
  <section className="bg-navy py-20 text-white sm:py-28 lg:py-32" data-testid="trust-section">
    <div className="container-x">
      <Reveal className="max-w-3xl">
        <p className="eyebrow-light">Why churches trust it</p>
        <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">Records a finance committee can stand behind.</h2>
      </Reveal>
      <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-0">
        {PILLARS.map((p, i) => (
          <Reveal key={p.t} delay={i * 0.1} className={`md:px-8 ${i > 0 ? "md:border-l md:border-white/15" : "md:pl-0"}`}>
            <p className="font-display text-5xl italic text-[#d9bd85]">{p.n}</p>
            <h3 className="mt-6 font-display text-3xl font-semibold" data-testid={`trust-pillar-${p.t.toLowerCase()}`}>{p.t}</h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-300">{p.b}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const ClosingCta = () => (
  <section className="hairline-grid bg-white py-20 sm:py-28 lg:py-32" data-testid="closing-cta-section">
    <div className="container-x">
      <Reveal className="grid gap-12 border border-[#c5a059]/45 bg-white p-8 sm:p-12 lg:grid-cols-12 lg:p-16">
        <div className="lg:col-span-7">
          <p className="eyebrow">See it for your church</p>
          <h2 className="h2 mt-4">Bring your books into good order.</h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600">Ask for a walkthrough with your own questions in hand, or join the waitlist to hear launch pricing first.</p>
        </div>
        <div className="flex flex-col justify-end gap-6 lg:col-span-5">
          <Link to="/demo" className="btn-primary" data-testid="cta-request-demo-button">Request a demo</Link>
          <WaitlistForm id="cta-waitlist" source="home-cta" />
        </div>
      </Reveal>
    </div>
  </section>
);
